module.exports = __webpack_public_path__ + "img/lock-red.1fba0309.svg";